/* eslint-disable sort-keys */
import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import {
   AccountNameResult,
   GlobalSearchListItem,
   MacAddressResult,
   PhoneNumberResult,
   SoftphoneUsernameResult,
} from '../models/global-search.model';
import * as GlobalSearchActions from './global-search.actions';

export const globalSearchReducerKey = 'globalSearch';

export interface GlobalSearchState {
   accounts: GlobalSearchListItem[];
   accountSearchCallState: CallState;
   devices: GlobalSearchListItem[];
   deviceSearchCallState: CallState;
   searchText: string;
   phoneNumbers: GlobalSearchListItem[];
   phoneNumberSearchCallState: CallState;
   softphoneUserNames: GlobalSearchListItem[];
   softphoneUserNamesSearchCallState: CallState;
}

const initialState: GlobalSearchState = {
   accounts: [],
   accountSearchCallState: LoadingState.Init,
   devices: [],
   deviceSearchCallState: LoadingState.Init,
   searchText: '',
   phoneNumbers: [],
   phoneNumberSearchCallState: LoadingState.Init,
   softphoneUserNames: [],
   softphoneUserNamesSearchCallState: LoadingState.Init,
};

export const globalSearchReducer = createReducer(
   onReset(initialState),
   on(GlobalSearchActions.globalSearchSearchTextChanged, (state, action) => {
      return {
         ...state,
         searchText: action.searchText,
         accountSearchCallState: LoadingState.Loading,
         deviceSearchCallState: LoadingState.Init,
         phoneNumberSearchCallState: LoadingState.Loading,
         softphoneUserNamesSearchCallState: LoadingState.Loading,
      };
   }),

   on(GlobalSearchActions.globalSearchDeviceSearched, (state, action) => {
      return {
         ...state,
         searchText: action.searchText,
         deviceSearchCallState: LoadingState.Loading,
      };
   }),
   on(GlobalSearchActions.globalSearchSearchResultCleared, (state) => {
      return {
         ...state,
         accounts: [],
         devices: [],
         phoneNumbers: [],
         softphoneUserNames: [],
         searchText: '',
      };
   }),
   on(GlobalSearchActions.globalSearchAccountsSearchResultSuccess, (state, action) => {
      return {
         ...state,
         accountSearchCallState: LoadingState.Loaded,
         accounts: action.accounts?.map((item: AccountNameResult) => {
            return {
               routerLink: ['/accountsettings', item?.accountId],
               title: item.name,
               searchType: 'Account',
            } as GlobalSearchListItem;
         }),
      };
   }),
   on(GlobalSearchActions.globalSearchDevicesSearchResultSuccess, (state, action) => {
      return {
         ...state,
         deviceSearchCallState: LoadingState.Loaded,
         devices: action.devices?.map((item: MacAddressResult) => {
            const linkPrefix = item.accountName !== '' ? '/accountdevices' : '/devices';
            return {
               routerLink: [linkPrefix, item?.deviceId],
               title: item.macAddress,
               subtitle: item.accountName,
               searchType: 'Device',
            } as GlobalSearchListItem;
         }),
      };
   }),

   on(GlobalSearchActions.globalSearchPhoneNumbersSearchResultSuccess, (state, action) => {
      return {
         ...state,
         phoneNumberSearchCallState: LoadingState.Loaded,
         phoneNumbers: action.phoneNumbers?.map((item: PhoneNumberResult) => {
            const linkPrefix = item.accountName !== '' ? '/accountphonenumbers' : '/phonenumbers';
            return {
               routerLink: [linkPrefix, item?.phoneNumberId],
               title: item?.phoneNumber,
               subtitle: item?.accountName,
               searchType: 'PhoneNumber',
            } as GlobalSearchListItem;
         }),
      };
   }),

   on(GlobalSearchActions.globalSearchSoftphoneUsernamesSearchResultSuccess, (state, action) => {
      return {
         ...state,
         softphoneUserNamesSearchCallState: LoadingState.Loaded,
         softphoneUserNames: action.softphoneUsernames?.map((item: SoftphoneUsernameResult) => {
            return {
               routerLink: ['/extensions', item?.extensionId],
               title: item?.userName + ' - ' + item.extensionNumber,
               subtitle: item?.accountName,
               searchType: 'SoftphoneUsername',
            } as GlobalSearchListItem;
         }),
      };
   }),

   on(GlobalSearchActions.globalSearchAccountsSearchResultFailure, (state, action) => {
      return {
         ...state,
         accountSearchCallState: action,
      };
   }),
   on(GlobalSearchActions.globalSearchDevicesSearchResultFailure, (state, action) => {
      return {
         ...state,
         deviceSearchCallState: action,
      };
   }),
   on(GlobalSearchActions.globalSearchPhoneNumbersSearchResultFailure, (state, action) => {
      return {
         ...state,
         phoneNumberSearchCallState: action,
      };
   }),
   on(GlobalSearchActions.globalSearchSoftphoneUsernamesSearchResultFailure, (state, action) => {
      return {
         ...state,
         softphoneUserNamesSearchCallState: action,
      };
   })
);
